module.exports = __webpack_public_path__ + "img/tax.f4116a08.svg";